<template>
  <div class="dmg-graph" :style="{width: `${width}px`, height: `${height}px`}" >
    <div class="dmg-container" :style="{gap: `${subGraphMargin}px`}" >
      <div v-if="component" v-for="cluster in clusters" class="dmg-graph" :style="graphStyle" >
        <div
          class="dmg-graph-container"
          :style="{'min-height': `${minSubGraphHeight || subGraphHeight || (columns ? height / columns : 1)}px`}" >
          <component
            ref="subGraph"
            :is="component"
            :data="cluster.data"
            :width="subGraphRealWidth"
            :height="subGraphHeight || (columns ? height / columns : height)"
            :x-label-rotate="-70"
            :showLegend="false"
            v-bind="cluster.props" />
        </div>
        <div class="dmg-graph-label" >
          {{ cluster.Caption }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true,
      type: Array
    },
    childProperties: {
      type: Object,
      default: () => ({})
    },
    subgraph: {
      type: Object,
      default: null
    },
    columns: {
      type: Number,
      default: 2,
      required: false
    },
    maxGraphs: {
      type: Number,
      default: 10
    },
    subGraphWidth: {
      type: Number,
      default: null
    },
    subGraphHeight: {
      type: Number,
      default: null
    },
    minSubGraphHeight: {
      type: Number,
      default: null
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    subGraphMargin: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      keyColors: null
    }
  },
  watch: {
    component: {
      immediate: true,
      handler () {
        this.updateKeyColors()
      }
    },
    component: {
      immediate: true,
      handler () {
        this.updateKeyColors()
      }
    }
  },
  computed: {
    component () {
      if (this.subgraph) {
        return this.subgraph.component
      }
      return null
    },
    clusters () {
      return this.data.slice(0, this.maxGraphs)
    },
    subGraphRealWidth () {
      if (this.subGraphWidth) {
        return this.subGraphWidth
      }
      if (!this.columns) {
        return this.width
      }
      return Math.floor((this.width - 20 - this.subGraphMargin * (this.columns - 1)) / this.columns)
    },
    graphStyle () {
      const style = {}
      if (this.columns) {
        style.width = `${this.subGraphRealWidth}px`
      }
      return style
    }
  },
  methods: {
    updateKeyColors () {
      this.$nextTick(() => {
        if (this.$refs.subGraph && this.$refs.subGraph.length && this.$refs.subGraph[0].keyColors) {
          this.keyColors = this.$refs.subGraph[0].keyColors.map(keyColor => {
            keyColor = Object.assign({}, keyColor)
            const match = keyColor.label.match(/^(.*)\s\(.+\)$/)
            if (match) {
              keyColor.label = match[1]
            }
            return keyColor
          })
        } else {
          this.keyColors = null
        }
      })
    }
  }
}
</script>

<style scoped>
.dmg-container {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
}
.dmg-graph-container {
    position: relative;
}
.dmg-graph {
    overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/DimensionMultipleGraph.vue